import { render, staticRenderFns } from "./AccordionContainerHeaderButton.vue?vue&type=template&id=203f4749&"
import script from "./AccordionContainerHeaderButton.vue?vue&type=script&lang=js&"
export * from "./AccordionContainerHeaderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports